import { Component } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

declare global {
  interface Window {
    cookiehub: any;
  }
}

@Component({
  selector: 'app-data-consent-revoke',
  templateUrl: './data-consent-revoke.component.html',
  styleUrls: ['./data-consent-revoke.component.scss'],
})
export class DataConsentRevokeComponent {
  openCookieHubPreferences() {
    if (window.cookiehub) {
      window.cookiehub.openSettings();
    }
  }
}
